import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function FAQ() {
  const { t } = useLang();
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section data-testid="faq-section" className="relative bg-black py-24 md:py-36 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="md:col-span-4"
          >
            <div className="text-xs tracking-[0.3em] uppercase font-bold text-[#FFCC00] mb-6">
              / 07 — {t.faq.overline}
            </div>
            <h2 data-testid="faq-title" className="font-display text-5xl md:text-6xl text-white leading-[0.92]">
              {t.faq.title}
            </h2>
          </motion.div>

          <div className="md:col-span-8">
            <div className="border-t border-white/10">
              {t.faq.items.map((item, i) => {
                const isOpen = openIdx === i;
                return (
                  <div key={i} className="border-b border-white/10" data-testid={`faq-item-${i}`}>
                    <button
                      onClick={() => setOpenIdx(isOpen ? -1 : i)}
                      className="w-full flex items-center justify-between gap-6 py-6 md:py-8 text-left group"
                      data-testid={`faq-toggle-${i}`}
                    >
                      <span className={`font-display text-2xl md:text-3xl transition-colors ${isOpen ? "text-[#FFCC00]" : "text-white group-hover:text-[#FFCC00]"}`}>
                        {item.q}
                      </span>
                      <span
                        className={`w-10 h-10 border flex items-center justify-center shrink-0 transition-all ${
                          isOpen ? "rotate-45 border-[#FFCC00] text-[#FFCC00]" : "border-white/20 text-white"
                        }`}
                      >
                        <Plus size={18} />
                      </span>
                    </button>
                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.3 }}
                          className="overflow-hidden"
                        >
                          <p className="pb-8 pr-12 text-white/70 font-body text-base leading-relaxed">
                            {item.a}
                          </p>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
